import { Link } from "react-router-dom";
import {
  FiBookOpen,
  FiClock,
  FiInbox,
  FiMail,
  FiMapPin,
  FiPhone,
  FiZap,
} from "react-icons/fi";
import "../styles/publicFooter.css";

export default function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="la-container public-footer-grid">
        <div className="public-footer-brand">
          <Link to="/" className="public-footer-logo-link" aria-label="LawAfrica home">
            <img src="/logo.png" alt="LawAfrica — Know. Do. Be More" />
          </Link>
          <p>
            Authoritative legal publications, digital reading and research tools
            from LawAfrica.
          </p>
          <div className="public-footer-publications" aria-label="LawAfrica legal publications">
            <span><FiBookOpen /> Commentaries</span>
            <span><FiBookOpen /> Statutes</span>
            <span><FiBookOpen /> Journals</span>
          </div>
        </div>

        <div className="public-footer-column">
          <strong>Platform</strong>
          <a href="/#discover">Explore</a>
          <a href="/#new-arrivals">New arrivals</a>
          <a href="/#legal-ai"><span className="public-footer-link-icon"><FiZap /></span>Legal AI</a>
        </div>

        <div className="public-footer-column">
          <strong>Access</strong>
          <Link to="/login">Sign in</Link>
          <Link to="/register">Public registration</Link>
          <a href="/#institutions">Institutions</a>
        </div>

        <div className="public-footer-column public-footer-contact">
          <strong>Contact Information</strong>
          <div className="public-footer-contact-list">
            <div className="public-footer-contact-item">
              <FiInbox aria-hidden="true" />
              <span>P.O Box 4260-00100</span>
            </div>
            <a
              className="public-footer-contact-item"
              href="https://lawafrica.com/"
              target="_blank"
              rel="noreferrer"
            >
              <FiMapPin aria-hidden="true" />
              <span>Longhorn Publishers PLC, Funzi Road, Industrial Area, Nairobi, Kenya</span>
            </a>
            <a className="public-footer-contact-item" href="mailto:info@lawafrica.com">
              <FiMail aria-hidden="true" />
              <span>info@lawafrica.com</span>
            </a>
            <a className="public-footer-contact-item" href="tel:+254797734012">
              <FiPhone aria-hidden="true" />
              <span>+254 797 734 012</span>
            </a>
            <div className="public-footer-contact-item">
              <FiClock aria-hidden="true" />
              <span>Mon-Fri 08:00 - 17:00 UTC+3</span>
            </div>
          </div>
        </div>
      </div>

      <div className="la-container public-footer-bottom">
        <span>© {new Date().getFullYear()} LawAfrica. All rights reserved.</span>
        <span>Digital Hub</span>
      </div>
    </footer>
  );
}
